import { render, staticRenderFns } from "./programs2.vue?vue&type=template&id=52617caf"
import script from "./programs2.vue?vue&type=script&lang=js"
export * from "./programs2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports